enum ApplicationEventNames {
    SetAdministrationLoading = 'setAdministrationLoading',
}

export default ApplicationEventNames;
